// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rolled-options-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.rolled-options-header {
  margin-bottom: 20px;
}

.rolled-options-header h2 {
  margin: 0 0 5px 0;
  color: #333;
}

.rolled-options-header .subtitle {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.rolled-options-table-container {
  overflow-x: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.rolled-options-table {
  width: 100%;
  border-collapse: collapse;
}

.rolled-options-table thead {
  background-color: #f5f5f5;
}

.rolled-options-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #ddd;
}

.rolled-options-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
}

.group-header-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.group-header-row:hover {
  background-color: #f9f9f9;
}

.group-header-row.positive {
  background-color: #f0f9f0;
}

.group-header-row.negative {
  background-color: #fff0f0;
}

.expand-cell {
  width: 40px;
  text-align: center;
}

.expand-button {
  background: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.expand-button:hover {
  background-color: #f0f0f0;
  border-color: #999;
}

.underlying-cell {
  font-weight: 600;
  color: #333;
}

.account-cell {
  color: #666;
}

.pnl-cell {
  font-weight: 600;
  text-align: right;
}

.pnl-cell.positive {
  color: #28a745;
}

.pnl-cell.negative {
  color: #dc3545;
}

.total-pnl {
  font-size: 16px;
}

.count-cell {
  text-align: center;
  color: #666;
}

.open-count {
  color: #ff9800;
  font-weight: 600;
}

.closed-count {
  color: #666;
}

.expanded-content-row {
  background-color: #fafafa;
}

.expanded-content-cell {
  padding: 20px !important;
}

.trades-detail-table {
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.trades-detail-table table {
  width: 100%;
  border-collapse: collapse;
}

.trades-detail-table thead {
  background-color: #e9e9e9;
}

.trades-detail-table th {
  padding: 8px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  border-bottom: 1px solid #ddd;
}

.trades-detail-table td {
  padding: 8px 12px;
  font-size: 13px;
  border-bottom: 1px solid #f0f0f0;
}

.trades-detail-table tr.open-trade {
  background-color: #fff9e6;
}

.trades-detail-table tr.closed-trade {
  background-color: white;
}

.conid-cell {
  font-family: monospace;
  font-size: 12px;
  color: #666;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.open {
  background-color: #ff9800;
  color: white;
}

.status-badge.closed {
  background-color: #666;
  color: white;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #666;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.error {
  background-color: #fee;
  color: #c33;
  padding: 15px;
  border-radius: 4px;
  margin: 20px 0;
}

.conid-groups-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.conid-group {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
}

.conid-group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.conid-group-header:hover {
  background-color: #f0f0f0;
}

.conid-expand-button {
  width: 24px;
  height: 24px;
  font-size: 16px;
  flex-shrink: 0;
}

.conid-group-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #555;
}

.conid-group-info strong {
  color: #333;
  font-weight: 600;
}

.conid-pnl {
  font-weight: 600;
  font-size: 14px;
}

.conid-pnl.positive {
  color: #28a745;
}

.conid-pnl.negative {
  color: #dc3545;
}

.open-badge {
  color: #ff9800;
  font-weight: 600;
  font-size: 12px;
}

.conid-group .trades-detail-table {
  margin: 0;
  border-top: 1px solid #e0e0e0;
}

`, "",{"version":3,"sources":["webpack://./src/RolledOptions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B","sourcesContent":[".rolled-options-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.rolled-options-header {\n  margin-bottom: 20px;\n}\n\n.rolled-options-header h2 {\n  margin: 0 0 5px 0;\n  color: #333;\n}\n\n.rolled-options-header .subtitle {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.rolled-options-table-container {\n  overflow-x: auto;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.rolled-options-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.rolled-options-table thead {\n  background-color: #f5f5f5;\n}\n\n.rolled-options-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #ddd;\n}\n\n.rolled-options-table td {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.group-header-row {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.group-header-row:hover {\n  background-color: #f9f9f9;\n}\n\n.group-header-row.positive {\n  background-color: #f0f9f0;\n}\n\n.group-header-row.negative {\n  background-color: #fff0f0;\n}\n\n.expand-cell {\n  width: 40px;\n  text-align: center;\n}\n\n.expand-button {\n  background: none;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: bold;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.expand-button:hover {\n  background-color: #f0f0f0;\n  border-color: #999;\n}\n\n.underlying-cell {\n  font-weight: 600;\n  color: #333;\n}\n\n.account-cell {\n  color: #666;\n}\n\n.pnl-cell {\n  font-weight: 600;\n  text-align: right;\n}\n\n.pnl-cell.positive {\n  color: #28a745;\n}\n\n.pnl-cell.negative {\n  color: #dc3545;\n}\n\n.total-pnl {\n  font-size: 16px;\n}\n\n.count-cell {\n  text-align: center;\n  color: #666;\n}\n\n.open-count {\n  color: #ff9800;\n  font-weight: 600;\n}\n\n.closed-count {\n  color: #666;\n}\n\n.expanded-content-row {\n  background-color: #fafafa;\n}\n\n.expanded-content-cell {\n  padding: 20px !important;\n}\n\n.trades-detail-table {\n  background: white;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.trades-detail-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.trades-detail-table thead {\n  background-color: #e9e9e9;\n}\n\n.trades-detail-table th {\n  padding: 8px 12px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  border-bottom: 1px solid #ddd;\n}\n\n.trades-detail-table td {\n  padding: 8px 12px;\n  font-size: 13px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.trades-detail-table tr.open-trade {\n  background-color: #fff9e6;\n}\n\n.trades-detail-table tr.closed-trade {\n  background-color: white;\n}\n\n.conid-cell {\n  font-family: monospace;\n  font-size: 12px;\n  color: #666;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.open {\n  background-color: #ff9800;\n  color: white;\n}\n\n.status-badge.closed {\n  background-color: #666;\n  color: white;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.error {\n  background-color: #fee;\n  color: #c33;\n  padding: 15px;\n  border-radius: 4px;\n  margin: 20px 0;\n}\n\n.conid-groups-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.conid-group {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.conid-group-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 15px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #e0e0e0;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.conid-group-header:hover {\n  background-color: #f0f0f0;\n}\n\n.conid-expand-button {\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.conid-group-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: #555;\n}\n\n.conid-group-info strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.conid-pnl {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.conid-pnl.positive {\n  color: #28a745;\n}\n\n.conid-pnl.negative {\n  color: #dc3545;\n}\n\n.open-badge {\n  color: #ff9800;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.conid-group .trades-detail-table {\n  margin: 0;\n  border-top: 1px solid #e0e0e0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
